<template>
    <div class="test-theme-page">
        <div class="container">
            <div class="test-theme-promo">
                <img src="https://admin.sales.bazis.kz/media/bazis-logo_2023.svg" alt="">
                <h1>SHABLON  2023 - 2025 ГОДА - Статус по проектам</h1>
            </div>
            <div class="test-sales-items">
                <div class="item">
                    <!-- <div class="item-logo">
                        <img :src="item.logo" alt="">
                    </div> -->
                    <div class="item-info">
                        <h2>Adamant</h2>
                        <div class="status">
                            <span>Запущен</span>
                            <!-- <span class="test">Тестирование</span> -->
                        </div>
                        <!-- <p>{{ item.shablon_link }}</p> -->
                        <a href="http://adamant.bazis.kz/" class="link" target="_blank">ОТКРЫТЬ</a>
                    </div>
                </div>
                <div class="item" v-for="(item, index) in salesItems" :key="index">
                    <!-- <div class="item-logo">
                        <img :src="item.logo" alt="">
                    </div> -->
                    <div class="item-info">
                        <h2>{{ item.project_name.name }}</h2>
                        <div class="status">
                            <span v-if="item.status == 'start'">Запущен</span>
                            <span v-else class="test">Тестирование</span>
                        </div>
                        <!-- <p>{{ item.shablon_link }}</p> -->
                        <a :href="item.shablon_link" class="link" target="_blank">ОТКРЫТЬ</a>
                    </div>
                </div>
                <div class="item">
                    <div class="item-info">
                        <h2>Adamant PLUS</h2>
                        <div class="status">
                            <!-- <span>Запущен</span> -->
                            <span class="test">Тестирование</span>
                        </div>
                        <!-- <p>{{ item.shablon_link }}</p> -->
                        <a href="http://adamantplus.test-shablon.bazis.kz/" class="link" target="_blank">ОТКРЫТЬ</a>
                    </div>
                </div>
                <div class="item">
                    <div class="item-info">
                        <h2>Summit</h2>
                        <div class="status">
                            <!-- <span>Запущен</span> -->
                            <span class="test">Тестирование</span>
                        </div>
                        <!-- <p>{{ item.shablon_link }}</p> -->
                        <a href="http://summit.test-shablon.bazis.kz/" class="link" target="_blank">ОТКРЫТЬ</a>
                    </div>
                </div>
                <div class="item">
                    <div class="item-info">
                        <h2>Epic</h2>
                        <div class="status">
                            <!-- <span>Запущен</span> -->
                            <span class="test">Тестирование</span>
                        </div>
                        <!-- <p>{{ item.shablon_link }}</p> -->
                        <a href="http://epic.test-shablon.bazis.kz/" class="link" target="_blank">ОТКРЫТЬ</a>
                    </div>
                </div>
                <div class="item">
                    <div class="item-info">
                        <h2>Fortis</h2>
                        <div class="status">
                            <!-- <span>Запущен</span> -->
                            <span class="test">Тестирование</span>
                        </div>
                        <!-- <p>{{ item.shablon_link }}</p> -->
                        <a href="http://fortis.test-shablon.bazis.kz/" class="link" target="_blank">ОТКРЫТЬ</a>
                    </div>
                </div>
                <div class="item">
                    <div class="item-info">
                        <h2>Alta</h2>
                        <div class="status">
                            <!-- <span>Запущен</span> -->
                            <span class="test">Тестирование</span>
                        </div>
                        <!-- <p>{{ item.shablon_link }}</p> -->
                        <a href="http://alta.test-shablon.bazis.kz/" class="link" target="_blank">ОТКРЫТЬ</a>
                    </div>
                </div>
                <div class="item">
                    <div class="item-info">
                        <h2>Cascade</h2>
                        <div class="status">
                            <!-- <span>Запущен</span> -->
                            <span class="test">Тестирование</span>
                        </div>
                        <!-- <p>{{ item.shablon_link }}</p> -->
                        <a href="http://cascade.test-shablon.bazis.kz/" class="link" target="_blank">ОТКРЫТЬ</a>
                    </div>
                </div>
                <div class="item">
                    <div class="item-info">
                        <h2>Elios</h2>
                        <div class="status">
                            <!-- <span>Запущен</span> -->
                            <span class="test">Тестирование</span>
                        </div>
                        <!-- <p>{{ item.shablon_link }}</p> -->
                        <a href="http://elios.test-shablon.bazis.kz/" class="link" target="_blank">ОТКРЫТЬ</a>
                    </div>
                </div>
                <div class="item">
                    <div class="item-info">
                        <h2>Vesper</h2>
                        <div class="status">
                            <!-- <span>Запущен</span> -->
                            <span class="test">Тестирование</span>
                        </div>
                        <!-- <p>{{ item.shablon_link }}</p> -->
                        <a href="http://vesper.test-shablon.bazis.kz/" class="link" target="_blank">ОТКРЫТЬ</a>
                    </div>
                </div>
                <div class="item">
                    <div class="item-info">
                        <h2>Tribeca</h2>
                        <div class="status">
                            <!-- <span>Запущен</span> -->
                            <span class="test">Тестирование</span>
                        </div>
                        <!-- <p>{{ item.shablon_link }}</p> -->
                        <a href="http://tribeca.test-shablon.bazis.kz/" class="link" target="_blank">ОТКРЫТЬ</a>
                    </div>
                </div>
                <div class="item">
                    <div class="item-info">
                        <h2>Manific</h2>
                        <div class="status">
                            <!-- <span>Запущен</span> -->
                            <span class="test">Тестирование</span>
                        </div>
                        <!-- <p>{{ item.shablon_link }}</p> -->
                        <a href="http://manific.test-shablon.bazis.kz/" class="link" target="_blank">ОТКРЫТЬ</a>
                    </div>
                </div>
                <!-- <div class="item">
                    <div class="item-info">
                        <h2>AuezovCityPro</h2>
                        <div class="status">
                            <span>Запущен</span>
                            <span class="test">Тестирование</span>
                        </div>
                        <a href="http://auezovcitypro.bazis.kz/" class="link" target="_blank">ОТКРЫТЬ</a>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'test-theme--page',
        components: {
        },
        data () {
            return {
                projectNameG: window.host,
                salesItems: null,
            }
        },
        methods: {
            getSalesItems() {
                window.SalesUrl = 'https://admin.sales.bazis.kz/';
                window.GlobalLang = '';
                axios.get(window.SalesUrl + window.GlobalLang + window.JsonUrl + 'sales/?per_page=100').then(async (response) => {
                    console.log(response.data, 'array houses');
                    this.InitCorrectItems(response.data);
                    this.$parent.$refs.topProgress.done();
                });
            },
            InitCorrectItems(items) {
                var filteredItems;
                var itemsArr = [];
                for (var i=0; i < items.length; i++) {
                    // console.log(i + 1, items[i].acf.project_name)
                    itemsArr.push({
                        project_name: items[i].acf.project_name,
                        logo: items[i].acf.logo_color,
                        // crm_code: items[i].acf.crm_code,
                    });
                }
                console.log(itemsArr, 'ASDASDASD')
                filteredItems = itemsArr.filter(item => {
                    return item.project_name.slug == 'riviera' ||
                            item.project_name.slug == 'auezovcity' ||
                            item.project_name.slug == 'auezov-city-pro' ||
                            item.project_name.slug == 'alfarabi27' ||
                            item.project_name.slug == 'jazzkvartal' ||
                            item.project_name.slug == 'estet' ||
                            item.project_name.slug == 'shahristan' ||
                            item.project_name.slug == 'soho2' ||
                            item.project_name.slug == 'grandmonaco' ||
                            item.project_name.slug == 'austria' ||
                            item.project_name.slug == 'landmark' ||
                            item.project_name.slug == 'lmgold' ||
                            item.project_name.slug == 'discovery' ||
                            item.project_name.slug == 'altyn-besik' ||
                            item.project_name.slug == 'zangar' ||
                            item.project_name.slug == 'evolution' ||
                            item.project_name.slug == 'orion-3' ||
                            item.project_name.slug == 'legenda' ||
                            item.project_name.slug == 'satpaev' ||
                            item.project_name.slug == 'jandostar' ||
                            item.project_name.slug == 'nurly-dala2' ||
                            item.project_name.slug == 'riviera-plus' ||
                            item.project_name.slug == 'noho' ||
                            item.project_name.slug == 'level' ||
                            item.project_name.slug == 'salzburg' ||
                            item.project_name.slug == 'duman' ||
                            item.project_name.slug == 'adamant' ||
                            item.project_name.slug == 'neopark' ||
                            item.project_name.slug == 'parkville' 
                });

                for (var i=0; i < filteredItems.length; i++) {
                    if (filteredItems[i].project_name.slug == 'zangar' || 
                        filteredItems[i].project_name.slug == 'discovery' || 
                        filteredItems[i].project_name.slug == 'evolution' ||
                        filteredItems[i].project_name.slug == 'riviera' ||
                        filteredItems[i].project_name.slug == 'austria' ||
                        filteredItems[i].project_name.slug == 'estet' ||
                        filteredItems[i].project_name.slug == 'orion-3' ||
                        filteredItems[i].project_name.slug == 'shahristan' ||
                        filteredItems[i].project_name.slug == 'auezovcity' ||
                        filteredItems[i].project_name.slug == 'alfarabi27' ||
                        filteredItems[i].project_name.slug == 'satpaev' ||
                        filteredItems[i].project_name.slug == 'landmark' ||
                        filteredItems[i].project_name.slug == 'lmgold' ||
                        filteredItems[i].project_name.slug == 'duman' ||
                        filteredItems[i].project_name.slug == 'grandmonaco' ||
                        filteredItems[i].project_name.slug == 'noho' ||
                        filteredItems[i].project_name.slug == 'adamant' ||
                        filteredItems[i].project_name.slug == 'riviera-plus' ||
                        filteredItems[i].project_name.slug == 'salzburg' ||
                        filteredItems[i].project_name.slug == 'parkville' ||
                        filteredItems[i].project_name.slug == 'level' ||
                        filteredItems[i].project_name.slug == 'neopark' ||
                        filteredItems[i].project_name.slug == 'jandostar') {
                        Object.assign(filteredItems[i], {
                            status: 'start',
                            shablon_link: 'https://' + filteredItems[i].project_name.slug + '.bazis.kz'
                        });
                    } else if (filteredItems[i].project_name.slug == 'auezov-city-pro') {
                        Object.assign(filteredItems[i], {
                            status: 'start',
                            shablon_link: 'http://auezovcitypro.bazis.kz'
                        });
                    } else if (filteredItems[i].project_name.slug == 'orion-3') {
                        Object.assign(filteredItems[i], {
                            status: 'test',
                            shablon_link: 'http://orion-3.test-shablon.bazis.kz'
                        });
                    } else if (filteredItems[i].project_name.slug == 'soho2') {
                        Object.assign(filteredItems[i], {
                            status: 'test',
                            shablon_link: 'http://soho2.test-shablon.bazis.kz'
                        });
                    } else if (filteredItems[i].project_name.slug == 'altyn-besik') {
                        Object.assign(filteredItems[i], {
                            status: 'start',
                            shablon_link: 'http://altyn-besik.bazis.kz'
                        });
                    } else if (filteredItems[i].project_name.slug == 'nurly-dala2') {
                        Object.assign(filteredItems[i], {
                            status: 'start',
                            shablon_link: 'http://nurlydala2.kz'
                        });
                    } else if (filteredItems[i].project_name.slug == 'jan-dostar') {
                        Object.assign(filteredItems[i], {
                            status: 'test',
                            shablon_link: 'http://jandostar.test-shablon.bazis.kz'
                        });
                    } else {
                        Object.assign(filteredItems[i], {
                            status: 'test',
                            shablon_link: 'http://' + filteredItems[i].project_name.slug + '.test-shablon.bazis.kz'
                        });
                    }
                }
                this.salesItems = filteredItems;
                this.salesItems.sort(function(a,b){
                // here a , b is whole object, you can access its property
                //convert both to lowercase
                    let x = a.status.toLowerCase();
                    let y = b.status.toLowerCase();

                //compare the word which is comes first
                    if(x>y){return 1;} 
                    if(x<y){return -1;}
                    return 0;
                });
                // console.log(this.salesItems, filteredItems, 'ASDASDASD')
            }
        },
        created() {
            this.getSalesItems();
        }
    }
</script>

<style lang="scss">
    // @import '@/styles/components/pages/test-theme-page.scss';
    @import '@/styles/components/pages/test-theme-page-new.scss';
</style>